import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn, createSpanIn} from '../../../../shared/scripts/ui_utils/DomUtils'

export class UIMRoomToggableButton {
    private readonly buttonContainer: HTMLDivElement
    private readonly activeIndicator: HTMLDivElement
    private isViewOnly: boolean
    private isActive: boolean

    constructor(container: HTMLDivElement, title: TranslationObject, icon: LobbyImage, active: boolean = false, isViewOnly: boolean = false, onClick?: (active: boolean) => void) {
        this.buttonContainer = createDivIn(container, 'm-room-settings-toggable-button-container')
        this.isViewOnly = isViewOnly

        const imageContainer = createDivIn(this.buttonContainer, 'm-room-settings-toggable-button-img-container')
        createImgIn(imageContainer, icon, 'm-room-settings-toggable-button-img')
        createSpanIn(this.buttonContainer, 'm-room-settings-toggable-button-title', title)
        this.activeIndicator = createDivIn(this.buttonContainer, 'm-room-settings-toggable-button-active-indicator hidden')

        if(active) {
            this.buttonContainer.classList.add('m-room-settings-toggable-button-container-active')
            this.activeIndicator.classList.toggle('hidden')
        }
        if(isViewOnly) {
            this.buttonContainer.classList.add('m-room-settings-toggable-button-container-view-only')
        }

        this.isActive = active
        this.buttonContainer.onclick = () => {
            if(this.isViewOnly) return
            onClick?.(!this.isActive)
        }
    }

    update(active: boolean, isViewOnly: boolean = false) {
        if(isViewOnly) {
            this.isViewOnly = true
            this.buttonContainer.classList.add('m-room-settings-toggable-button-container-view-only')
        } else {
            this.isViewOnly = false
            this.buttonContainer.classList.remove('m-room-settings-toggable-button-container-view-only')
        }
        if(active) {
            this.isActive = true
            this.buttonContainer.classList.add('m-room-settings-toggable-button-container-active')
            this.activeIndicator.classList.remove('hidden')
        } else {
            this.isActive = false
            this.buttonContainer.classList.remove('m-room-settings-toggable-button-container-active')
            this.activeIndicator.classList.add('hidden')
        }
    }
}
